import React from 'react';
import { Button } from 'antd';
import ArchiveRowAction from '../archive_row_action/ArchiveRowAction';

interface MeterRowActionsProps {
	record: any;
	onAddReadingClick: (e: any, record: any) => void;
	onArchive: (meter: any) => Promise<any> | void;
	onUnarchive: (meter: any) => Promise<any> | void;
}

/**
 * Action cell for a meters table row: "Add Reading" plus Archive/Unarchive.
 * Archive/unarchive defer the write behind an Undo toast (`deferred`), so no spinner
 * is shown and the toast is the feedback.
 */
export const MeterRowActions: React.FC<MeterRowActionsProps> = ({
	record,
	onAddReadingClick,
	onArchive,
	onUnarchive,
}) => {
	return (
		<div className="flex flex-row items-center justify-end gap-2">
			<Button onClick={(e) => onAddReadingClick(e, record)}>Add Reading</Button>
			<ArchiveRowAction entity={record} onArchive={onArchive} onUnarchive={onUnarchive} deferred />
		</div>
	);
};

export default MeterRowActions;
